import React, { useContext, useEffect } from "react";

import { Icon } from "components";
import useBindToContext from "hooks/useBindToContext";
import styles from "styles/product_selector.module.scss";
import ShopContext from "context/ShopContext";
import { formatMoney } from "components/cart/Utils";

const ProductSelector = ({
	products,
	context,
	showCreate,
	reducer,
	BindToContext = null,
	value = null,
	onChange = null,
	presets = false,
	selectedProduct
}) => {
	const [BindedValue, BindedOnChange, __, onRender] = useBindToContext(BindToContext, value, onChange);
	const {
		state: { money_format }
	} = useContext(ShopContext);
	//useEffect(() => {
		//if (onRender?.length) onRender.forEach(fn => fn());
	//}, [onRender]);

	return (
		<div className={styles.container}>
			{products.length > 0 &&
				products.map((product, key) => {
					// console.log(product)
					const selected = BindedValue ? product.id.toString() === BindedValue.id : false;
					return (
						<div
							className={styles.tile}
							data-selected={!!selected}
							key={key}
							onClick={() =>
								presets
									? onChange(product.id)
									: BindedOnChange({ ...reducer(product), image: product.image.src })
							}
						>
							<div
								className={`${styles.product} ${selected ? styles.selected : ""}`}
								key={`p-${product.id}`}
								style={{
									backgroundImage: `url(${product.image.src ? product.image.src : product.image})`
								}}
							></div>
							<div className={styles.title}>{product.title}</div>
							<div
								className={styles.priceTag}
								dangerouslySetInnerHTML={{
									__html: formatMoney(
										(presets ? product.price : product.variants[0].price) * 100,
										money_format
									)
								}}
							>
								{}
							</div>
						</div>
					);
				})}
			{!presets && (
				<div className={styles.add} onClick={() => showCreate()}>
					<div className={styles.inside}>
						<div>Create New</div>
						<Icon icon="plus" size="lg" style={{ color: "#a2a2a2" }} />
					</div>
				</div>
			)}
		</div>
	);
};

export default ProductSelector;
